import React, { Component } from 'react';
import { connect } from 'react-redux';
import BzmHeaderWrapper from 'views/Layout/CommonHeader/BzmHeaderWrapper/BzmHeaderWrapper';
import { ApplicationState } from 'store/rootReducer';
import { fetchBlazeUserConfigThunk } from 'store/blazeUserConfig/blazeUserConfigActions';
import { loadDevOptions } from '../../../utils/localStorageUtil';
import _ from 'lodash';
import { getActiveAccountId, hasUserAdminRoles } from '../../../utils/bzmUserConfigUtil';
import mixpanelService from '../../../utils/mixpanelService';
import { BZM_HEADER_LOGO_CLICK, BZM_HEADER_SUBSCRIPTION_BTN_CLICK } from '../../../utils/mixpanelEvents';

type AllProps = StateProps & DispatchProps;

class CommonHeader extends Component<AllProps> {
  componentDidMount() {
    this.props.fetchBlazeUserConfig();
    this.attachToHeaderEventEmittors();
  }

  /**
   * Attaches to header events.
   */
  attachToHeaderEventEmittors = () => {
    try {
      document.addEventListener('bzmHeaderSubscriptionBtnClicked', this.handleBZMHeaderSubscriptionBtnClick);
      document.addEventListener('bzmHeaderLogoClicked', this.handleBZMHeaderLogoClick);
    } catch (e) {
      console.log('Cannot register bzm-header events.');
    }
  };

  handleBZMHeaderLogoClick = () => {
    mixpanelService.track(BZM_HEADER_LOGO_CLICK());
  };
  handleBZMHeaderSubscriptionBtnClick = () => {
    mixpanelService.track(BZM_HEADER_SUBSCRIPTION_BTN_CLICK());
  };

  render() {
    let email = null;
    let bzmUrl = null;

    //Fill in props
    if (this.props.blazeUserConfig != null) {
      if (this.props.blazeUserConfig.user.email != null) {
        email = this.props.blazeUserConfig.user.email;
      }
      if (this.props.blazeUserConfig.user.account != null) {
        if (this.props.blazeUserConfig.user.account.appUrl != null) {
          bzmUrl = this.props.blazeUserConfig.user.account.appUrl;
        }
      }
    }

    if (email == null || bzmUrl == null) {
      return null;
    }

    const isStatusPageDisabled = _.get(loadDevOptions(), 'disableStatusPage');
    const accountId = getActiveAccountId();
    const upgradeUrl = accountId ? `/app/#/settings/accounts/${accountId}/billing?openUpgrade` : bzmUrl;

    return (
      <BzmHeaderWrapper
        email={email}
        bzmUrl={bzmUrl}
        disableStatusPage={!_.isNil(isStatusPageDisabled) ? isStatusPageDisabled : false}
        pathToSubscriptionUpgrade={upgradeUrl}
        shouldDisplaySubscription={hasUserAdminRoles(this.props.blazeUserConfig)}
      />
    );
  }
}

function mapStateToProps(state: ApplicationState) {
  return {
    blazeUserConfig: state.blazeUserConfig.blazeUserConfig,
    isLoading: state.blazeUserConfig.isLoading,
    viewAsUser: state.blazeUserConfig.viewAsUser,
    isPrivateCloudReadOnly: state.blazeUserConfig.isPrivateCloudReadOnly,
  };
}

const mapDispatchToProps = {
  fetchBlazeUserConfig: fetchBlazeUserConfigThunk,
};

type DispatchProps = typeof mapDispatchToProps;
type StateProps = ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(CommonHeader);
